/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-24 17:18:31
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-24 09:59:57
 */
/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-24 17:18:31
 * @LastEditors: TangXihao
 * @LastEditTime: 2020-12-29 14:33:50
 */
import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Avatar, Badge, Dropdown, Menu, message } from 'antd';
import { Link, } from 'react-router-dom';
import axios from 'axios';
import { ChangeRoom, DeleteFriend } from '../../../../store/actionCreators';
import { addchat, gettalkListonline } from '../../../../service/loginaction';
import FreeScrollbar from '../../../components/滚动条';
import { loadfriendList } from '../service/loaddata'

class Chat_Friends extends React.Component {
    state = {
        sections: [],
        letterArr: [],
        loading: true,
    };
    async componentDidMount() {

        // console.log(this.props)
        console.log("this.props.friendList", this.props.friendList[0])
        await loadfriendList(this.props.user);
    }

    // shouldComponentUpdate(nextProps,nextState) {
    //     console.log(nextProps.friendList)

    //     return true
    //  }

    setfriendchat = async (touser) => {
        // debugger
        let room = await addchat(touser, 'private')
        console.log(room, touser)
        this.props.ChangeRoom(
            {
                roomInfo: {
                    type: 'private',
                    roomId: '/private/' + room.receiverId,
                    chatName: room.contactName,
                }
            }
        )

        this.props.settotalklist()
        this.props.history.push('/Chat/Room');
    }

    findfriendchat = async () => {
    }

    deletefriend = async (friendInfo, index) => {
        await axios.delete(`${global.serviceUrl.chat}/friend/del`, {
            params: {
                user1: this.props.user.userId,
                user2: friendInfo.userId
            }
        }).then((data) => {
            data = data.data
            if (data.code === '200') {
                message.success('删除好友成功！')
                //   debugger
                this.props.DeleteFriend({ userId: friendInfo.userId })
                gettalkListonline()
                // console.log(this.props.friendList)
            } else {
                message.error(data.message)
            }
        }).catch((e) => {
        })
    }

    //发起聊天
    // 每一个好友  项
    // _renderItem(friendInfo, index) {
    //     // debugger
    //     // friendInfo = friendInfo.friendInfo
    //     // const { showIndex } = this.state;   
    //     const deletefriend = async () => {
    //       await  axios.delete(`${global.serviceUrl.chat}/friend/del`, {
    //             params: {
    //                 user1: this.props.user.userId,
    //                 user2: friendInfo.userId
    //             }
    //         }).then((data) => {
    //             data = data.data
    //             if (data.code === '200') {
    //                 message.success('删除好友成功！')
    //                 debugger
    //                 this.props.DeleteFriend({ userId: friendInfo.userId })
    //                 // console.log(this.props.friendList)
    //             } else {
    //                 message.error(data.message)
    //             }
    //         }).catch((e) => {
    //         })
    //     }
    //     const menu = <Menu>
    //         <Menu.Item key="1" onClick={deletefriend}>{'删除好友'}</Menu.Item>
    //     </Menu>
    //     // console.log(friendInfo);
    //     return (
    //         <div key={index}>
    //             <Dropdown overlay={menu} trigger={['contextMenu']}>
    //                 <div onDoubleClick={this.setfriendchat.bind(this, friendInfo)} style={{ display: (friendInfo.userName.indexOf(this.props.searchtext) != -1) ? 'flex' : 'none' }}>
    //                     <div className='chat-friendlist-entity'>
    //                         <Avatar src={friendInfo.avatar} className={'chat-friendlist-entity-avatar'} ></Avatar>
    //                         <div className='chat-friendlist-entity-text'>
    //                             {/* {item.friendInfo.userName} */}
    //                             {friendInfo.userName.split(this.props.searchtext).map((text, index) => {
    //                                 return (<span key={index}><span style={{ background: 'yellow' }}>{index !== 0 && this.props.searchtext}</span><span>{text}</span></span>)
    //                             })}
    //                         </div>
    //                     </div>
    //                 </div>
    //             </Dropdown>
    //             <div className='chat-friendlist-entity-divider'> </div>
    //         </div>
    //     );
    // }
    render() {
        const { letterArr, sections } = this.state;
        // console.log("this.props.friendList", this.props.friendList)
        const menu = (data, index) => <Menu>
            <Menu.Item key="1" onClick={() => this.deletefriend(data, index)}>{'删除好友'}</Menu.Item>
        </Menu>
        return (
            // <div className='chatlist-list-scroll' >
            <FreeScrollbar className='chatlist-customscroll'>
                <Link to='/Chat/NewFriend' className='chat-friendlist-entity'>
                    <Avatar src={require('../../../../resources/img/icon_info.png')} className={'chat-friend-new-avatar'} ></Avatar>
                    <div className='chat-friendlist-entity-text'> 新的朋友</div>
                    <Badge className='chat-friendlist-badge' count={this.props.friendApplication.filter(a => a.validateFlag === '0').length}></Badge>
                </Link>
                <div className='chat-friendlist-divider'>
                </div>
                {this.props.friendList.map((data, index) => {


                    // console.log("检查好友列表头像：",data);
                    let avatarUrl=global.yunguanAvatar+'/'+data.avatar;
                    console.log("检查好友列表头像：",avatarUrl);
                    return (
                        <div key={index}>
                            <Dropdown overlay={() => menu(data, index)} trigger={['contextMenu']}>
                                <div onDoubleClick={this.setfriendchat.bind(this, data)} style={{ display: (data.userName && data.userName.indexOf(this.props.searchtext) != -1) ? 'flex' : 'none' }}>
                                    <div className='chat-friendlist-entity'>
                                        <Avatar src={avatarUrl} className={'chat-friendlist-entity-avatar'} ></Avatar>
                                        <div className='chat-friendlist-entity-text'>
                                            {/* {item.friendInfo.userName} */}
                                            {data.userName && data.userName.split(this.props.searchtext).map((text, index) => {
                                                return (<span key={index}><span style={{ background: 'yellow' }}>{index !== 0 && this.props.searchtext}</span><span>{text}</span></span>)
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </Dropdown>
                            <div className='chat-friendlist-entity-divider'> </div>
                        </div>
                    )
                })}
            </FreeScrollbar>
            // </div>
        );
    }
}
const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
    friendList: state.userReducer.get('friendList').toJS(),
    friendApplication: state.userReducer.get('friendApplication').toJS(),
    // messageList: state.messageReducer.get('messageList').toJS(),
    // activeRoom: state.userReducer.get('activeRoom'),
})

const mapDispatch = dispatch => ({
    ChangeRoom(param) {
        dispatch(ChangeRoom(param))
    }, DeleteFriend(param) {
        dispatch(DeleteFriend(param))
    }
})

export default connect(
    mapState,
    mapDispatch
)(Chat_Friends)
